import React from 'react';

import { List } from './List';
import { Edit } from './Edit';

export const eventsSampleRoutes = {
  path: '/eventsSample',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id/edit',
      element: <Edit slug='/eventsSample' />,
    },
    {
      path: 'add',
      element: <Edit slug='/eventsSample' />,
    },
  ],
};
